import { resolveAsset } from '@/core/utils/common.utils';
import { Howl } from 'howler';

export class SoundManager {
    private static backgroundMusic: Howl | null = null;
    private static sounds: { [key: string]: Howl } = {};
    private static isLoaded = false;
    private static movement: Howl | null = null;

    public static async init() {
        if (this.isLoaded) return;

        // iOS unlock
        const unlock = () => {
            Howler.ctx?.resume();
            
            document.removeEventListener('touchstart', unlock);
            document.removeEventListener('touchend', unlock);
        };
        document.addEventListener('touchstart', unlock, { once: true });
        document.addEventListener('touchend', unlock, { once: true });

        const soundFiles = {
            'melee_hit': resolveAsset('@assets/audio/melee_hit.ogg'),
            'melee_miss': resolveAsset('@assets/audio/melee_miss.ogg'),
            'ranged_hit': resolveAsset('@assets/audio/ranged_hit.ogg'),
            'ranged_miss': resolveAsset('@assets/audio/ranged_miss.ogg'),
            'movement': resolveAsset('@assets/audio/movement.ogg'),
        };

        for (const [key, path] of Object.entries(soundFiles)) {
            this.sounds[key] = new Howl({
                src: [path],
                preload: true,
                html5: false
            });
        }
console.log('SoundManager', this.sounds)
        await Promise.all(
            Object.values(this.sounds).map(s => new Promise(r => s.once('load', r)))
        );

        this.isLoaded = true;
    }


    public static playAttackSound(isMiss: boolean, range: number) {
        const key = `${range > 2 ? 'ranged' : 'melee'}_${isMiss ? 'miss' : 'hit'}`;
        const sound = this.sounds[key];

        if (sound && sound.state() === 'loaded') {
            const id = sound.play();
            sound.rate(0.9 + Math.random() * 0.2, id);
        } else {
            console.warn(`Sound ${key} not ready or not found`);
        }
    }

    public static playMovementSound() {
        
        const sound = this.sounds['movement'];

        if (sound && sound.state() === 'loaded') {
            const id = sound.play();
            sound.rate(0.9 + Math.random() * 0.2, id);
        } else {
            console.warn(`Sound movement not ready or not found`);
        }
    }

    public static stopMovementSound() {
        
        const sound = this.sounds['movement'];
// console.log('stopMovementSound', sound)
        if (sound && sound.state() === 'loaded') {
            sound.stop();
        } else {
            console.warn(`Sound movement not stopped`);
        }
    }

    /**
     * Запуск фонової музики
     * @param trackPath Шлях до файлу (напр. 'assets/audio/ambient_battle.mp3')
     */
    public static playBackground(trackPath: string) {
        // Якщо музика вже грає, не запускаємо її знову
        if (this.backgroundMusic) return;

        this.backgroundMusic = new Howl({
            src: [trackPath],
            html5: false, // Важливо для довгих файлів (економить пам'ять)
            loop: true,
            volume: 0,   // Починаємо з тиші для плавного входу
            autoplay: true,
        });

        // Плавне наростання гучності до 50% за 2 секунди
        this.backgroundMusic.fade(0, 0.15, 2000);
    }

    /**
     * Зупинка музики з плавним згасанням
     */
    public static stopBackground() {
        if (this.backgroundMusic) {
            this.backgroundMusic.fade(this.backgroundMusic.volume(), 0, 1500);
            this.backgroundMusic.once('fade', () => {
                this.backgroundMusic?.stop();
                this.backgroundMusic = null;
            });
        }
    }

    /**
     * Зміна гучності (наприклад, для налаштувань гри)
     */
    public static setVolume(value: number) {
        this.backgroundMusic?.volume(value);
    }

    public static destroy() {
        Object.values(this.sounds).forEach(s => s.unload());
        this.sounds = {};
        this.backgroundMusic?.unload();
        this.backgroundMusic = null;
        this.isLoaded = false;
    }
}